import React, { useContext } from 'react';
import { PrimaryActionHighlightBox } from '../../Shared/PrimaryActionHighlightBox';
import { PrimaryActionButton, PrimaryActionLinkButton } from '../../Shared/PrimaryActionButton';
import { UserRoleGate } from '../../../common/components/UserRoleGate';
import { CustomerRole } from '@edgebox/data-definitions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/pro-light-svg-icons/faClock';
import { AppContext } from '../../../common/contexts/AppContext';

const CONTENT_CLOUD_REQUEST_ACCESS_URL = 'https://www.content-sync.io/contact?topic=content-cloud-access';

export function ContentCloudPitch({ onClick, reverse }: { reverse?: boolean; onClick: () => void }) {
  const app = useContext(AppContext);
  if (reverse) {
  }

  return (
    <PrimaryActionHighlightBox>
      <h2 className="m-0">Fall in love with Drupal + frontend development</h2>
      {reverse ? (
        <div>
          Use our auto-generated client packages to access Drupal content in a highly optimized format and never worry about writing REST
          requests or GraphQL queries again. Set up custom user data stores to create highly customized user journeys at scale.
          <p className="text-muted mt-2">
            <FontAwesomeIcon icon={faClock} /> 15 minutes
          </p>
        </div>
      ) : (
        <div>
          Connect a source space to share content with your Content Cloud. Drupal content types will be automatically optimized for headless
          use-cases and added to your content model in this space.
          <p className="text-muted mt-2">
            <FontAwesomeIcon icon={faClock} /> 15 minutes
          </p>
        </div>
      )}

      <UserRoleGate
        allowed={[CustomerRole.Owner, CustomerRole.ManageSites]}
        ifDisallowed={
          <p>
            <em>Reach out to your account owner to enable this feature.</em>
          </p>
        }
      >
        {() =>
          reverse && !app.hasContentCloudProject ? (
            <>
              <PrimaryActionLinkButton className="mt-2" to={CONTENT_CLOUD_REQUEST_ACCESS_URL} external>
                Request access
              </PrimaryActionLinkButton>
            </>
          ) : (
            <>
              <PrimaryActionButton className="mt-2" onClick={onClick}>
                {reverse ? 'Add Content Cloud' : 'Connect Drupal'}
              </PrimaryActionButton>
            </>
          )
        }
      </UserRoleGate>
    </PrimaryActionHighlightBox>
  );
}
